module.exports = __webpack_public_path__ + "img/rl_structure_infogp.3e4f12ef.svg";